import React from 'react'
import { Elements, StripeProvider } from 'react-stripe-elements'
import CardUI from '../../widgets/layout/CardUI'
import CreditCardForm from './CreditCardForm'
import './AccountCreate.css'

const AccountCreateUI = ({context, messageList,
  // accountName
  accountName, onAccountNameChange, accountNameError, setAccountNameError,
  // countryCode
  countryCode, countryList, onCountryCodeChange, countryCodeError,
  // price
  priceId, priceList, onPriceIdChange, priceIdError,
  // card
  stripeApiKey,
  // form
  onSubmit, submitted, successMsg, errorList, setErrorList,
  }) =>
  <CardUI className='cona_acc_crt'>
    <StripeProvider apiKey={stripeApiKey}>
      <Elements locale={context.locale}>
        <CreditCardForm context={context} messageList={messageList}
          accountName={accountName} onAccountNameChange={onAccountNameChange}
          accountNameError={accountNameError} setAccountNameError={setAccountNameError}
          countryCode={countryCode} countryList={countryList} onCountryCodeChange={onCountryCodeChange} countryCodeError={countryCodeError}
          priceId={priceId} priceList={priceList} onPriceIdChange={onPriceIdChange} priceIdError={priceIdError}
          stripeApiKey={stripeApiKey}
          onSubmit={onSubmit} submitted={submitted}
          successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
        />
      </Elements>
    </StripeProvider>
  </CardUI>

export default AccountCreateUI
